var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Flex, Spin, theme } from "antd";
const Loader = ({ size, overlay = false, fullScreen = false, styles = {} }) => {
  const { token } = theme.useToken();
  const style = __spreadValues({
    position: overlay ? fullScreen ? "fixed" : "absolute" : "static",
    top: 0,
    left: 0,
    width: "100%",
    height: overlay ? "100vh" : "300px",
    minHeight: "300px",
    backgroundColor: overlay ? token.colorOverlayBG : "transparent",
    zIndex: overlay ? 1e3 : "auto"
  }, styles);
  return /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style, children: /* @__PURE__ */ jsx(Spin, { size, className: "app-loader" }) });
};
var stdin_default = memo(Loader);
export {
  stdin_default as default
};
